import React, { useEffect, useState, useRef } from 'react';
import { TextField, Button, Grid, Paper, Typography, MenuItem, Autocomplete, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../api/api';
import { useNavigate } from 'react-router-dom';

export default function CourierRequestForm() {

  const { user, token } = useAuth();
  const navigate = useNavigate();

  const [managers, setManagers] = useState([]);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    if (user) {
      const tempValues = { ...formValue }
      tempValues.empId = user.employee_code;
      tempValues.empName = user['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
      setFormValue(tempValues);
    }
  }, [user]);

  const [materials, setMaterials] = useState([]);
  const [urgencyList, setUrgencyList] = useState([]);

  useEffect(() => {
    fetchMaterials();
    fetchUrgencyLevelList();
  }, []);

  const fetchMaterials = () => {
    api.get('/api/CourierMaterialType')
      .then(response => {
        setMaterials(response.data);
      })
      .catch(error => {
        console.log('Error fecthing Material List', error);
      });
  }

  const fetchUrgencyLevelList = () => {
    try {
      const response = urgencyLevelList;
      setUrgencyList(response);
    }
    catch (error) {
      console.error('Error fetching Type of Materials', error);
    }
  }

  const [formValue, setFormValue] = useState({
    empId: '',
    empName: '',
    fromLocation: '',
    toLocation: '',
    modeOfPickup: 'directPickupByCourierOffice',
    gatepassType: 'rgp',
    gatepassNumber: '',
    urgencyLevel: '',
    materialId: '',
    courierType: 'domestic',
    purpose: '',
    approvalManager: '',
  });

  const itemList = [
    { id: 0, name: "Sample" },
    { id: 1, name: "Chemical" },
    { id: 2, name: "Document" },
    { id: 3, name: "Flammable" },
    { id: 4, name: "Glass Item" },
    { id: 5, name: "Electronic Item" },
    { id: 6, name: "Domestic/International" },
  ];

  const urgencyLevelList = [
    { id: 0, name: "Lowest" },
    { id: 1, name: "Low" },
    { id: 2, name: "Medium" },
    { id: 3, name: "High" },
    { id: 4, name: "Critical" },
  ];

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValue((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  }

  const fromLocationRef = useRef(null);
  const toLocationRef = useRef(null);
  const fromLocationAutocomplete = useRef(null);
  const toLocationAutocomplete = useRef(null);

  useEffect(() => {
    fromLocationAutocomplete.current = new window.google.maps.places.Autocomplete(fromLocationRef.current);
    toLocationAutocomplete.current = new window.google.maps.places.Autocomplete(toLocationRef.current);

    fromLocationAutocomplete.current.addListener('place_changed', () => {
      const place = fromLocationAutocomplete.current.getPlace();
      setFormValue((prevValues) => ({
        ...prevValues,
        fromLocation: place.name + ", " + place.formatted_address,
      }));
      calculateDistance();
    });

    toLocationAutocomplete.current.addListener('place_changed', () => {
      const place = toLocationAutocomplete.current.getPlace();
      setFormValue((prevValues) => ({
        ...prevValues,
        toLocation: place.name + ", " + place.formatted_address,
      }));
      calculateDistance();
    });

    api.get('/api/Users/get_managers')
      .then(response => {
        setManagers(response.data);
      })
      .catch(error => {
        console.error('Error fetching managers', error);
      });

    api.get('/api/Employees')
      .then(response => {
        setEmployees(response.data);
      })
      .catch(error => {
        console.error('Error fetching managers', error);
      });

  }, []);

  const calculateDistance = () => {
    if (!fromLocationAutocomplete.current.getPlace() || !toLocationAutocomplete.current.getPlace()) return;

    const origin = fromLocationAutocomplete.current.getPlace().formatted_address;
    const destination = toLocationAutocomplete.current.getPlace().formatted_address;

    const service = new window.google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: window.google.maps.UnitSystem.METRIC,
      },
      (response, status) => {
        if (status === 'OK') {
          const distanceValue = response.rows[0].elements[0].distance.value / 1000; // Convert meters to kilometers
          setFormValue((prevValues) => ({
            ...prevValues,
            tentativeKm: Math.round(distanceValue),
          }));
        } else {
          console.error(`Error calculating distance: ${status}`);
        }
      }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const requestData = {
      employeeId: +user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
      approvalManagerId: formValue.approvalManager,
      // employeeName: formValue.empName,
      fromLocation: formValue.fromLocation,
      toLocation: formValue.toLocation,
      modeOfPickup: formValue.modeOfPickup === 'directPickupByCourierOffice' ? 0 : formValue.modeOfPickup === 'handOverToAdmin' ? 1 : 2,
      gatepassType: formValue.gatepassType === 'rgp' ? 0 : 1,
      gatepassNumber: formValue.gatepassNumber,
      urgencyLevel: formValue.urgencyLevel,
      typeOfMaterialId: formValue.materialId,
      courierType: formValue.courierType === 'domestic' ? 0 : 1,
      purpose: formValue.purpose
    };
    console.log('Payload: ', requestData);
    api.post('/api/CourierRequests', requestData)
    .then(response => {
      navigate('/courier-request')
    })
    .catch(error => {
      console.error('Error submitting request', error);
      // Handle error
    });
  }

  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 1200,
        margin: 'auto'
      }}
    >
      <Typography marginBottom={2} component="p" variant="h5">New Courier Request</Typography>
      <form sx={{ top: 200 }} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Emp. ID"
              name="empId"
              value={formValue.empId}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Emp Name"
              name="empName"
              value={formValue.empName}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="From Location"
              name="fromLocation"
              value={formValue.fromLocation}
              onChange={handleInputChange}
              inputProps={{ required: true}}
              inputRef={fromLocationRef}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="To Location"
              name="toLocation"
              value={formValue.toLocation}
              onChange={handleInputChange}
              inputProps={{ required: true }}
              inputRef={toLocationRef}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Mode of Pickup</FormLabel>
              <RadioGroup
                row
                name="modeOfPickup"
                value={formValue.modeOfPickup}
                onChange={handleInputChange}
              >
                <FormControlLabel value="directPickupByCourierOffice" control={<Radio />} label="Direct pickup by courier office" />
                <FormControlLabel value="handOverToAdmin" control={<Radio />} label="Handover to admin" />
                <FormControlLabel value="self" control={<Radio />} label="Self" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Gate Pass Type</FormLabel>
              <RadioGroup
                row
                name="gatepassType"
                value={formValue.gatepassType}
                onChange={handleInputChange}
              >
                <FormControlLabel value="rgp" control={<Radio />} label="RGP" />
                <FormControlLabel value="nrgp" control={<Radio />} label="NRGP" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Gate Pass Number"
              name="gatepassNumber"
              value={formValue.gatepassNumber}
              onChange={handleInputChange}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Urgency Level"
              name="urgencyLevel"
              value={formValue.urgencyLevel}
              onChange={handleInputChange}
              inputProps={{ required: true }}
              fullWidth
              required
              select
            >
              {urgencyList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              label="Type of Material"
              name="materialId"
              value={formValue.materialId}
              onChange={handleInputChange}
              inputProps={{ required: true }}
              fullWidth
              required
              select
            >
              {materials.map((material) => (
                <MenuItem key={material.id} value={material.id}>
                  {material.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Courier Type</FormLabel>
              <RadioGroup
                row
                name="courierType"
                value={formValue.courierType}
                onChange={handleInputChange}
              >
                <FormControlLabel value="domestic" control={<Radio />} label="Domestic" />
                <FormControlLabel value="international" control={<Radio />} label="International" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Purpose of requirement"
              name="purpose"
              value={formValue.purpose}
              onChange={handleInputChange}
              inputProps={{ required: true }}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              disablePortal
              options={managers}
              getOptionLabel={(manager) => manager.name}
              getOptionKey={(manager) => manager.id}
              onChange={(event, value) => setFormValue((prevValues) => ({
                ...prevValues,
                approvalManager: value?.id || ''
              }))}
              value={managers.find(manager => manager.id === formValue.approvalManager) || null}
              sx={{ width: '100%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Approval Manager"
                  required
                />
              )}
            />
          </Grid>
        </Grid>

        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ marginTop: 4 }}>
          Submit
        </Button>
      </form>
    </Paper>
  );
}